import { render, staticRenderFns } from "./DeductionDetailDialog.vue?vue&type=template&id=a3716876&scoped=true"
import script from "./DeductionDetailDialog.vue?vue&type=script&lang=js"
export * from "./DeductionDetailDialog.vue?vue&type=script&lang=js"
import style0 from "./DeductionDetailDialog.vue?vue&type=style&index=0&id=a3716876&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a3716876",
  null
  
)

export default component.exports